<template>
    <div class="grid gap-2">
        <label>
            <input
                v-model="showLabels"
                type="checkbox"
            />
            Show labels next to checkboxes
        </label>

        <form
            class="mb-2 justify-self-start rounded-md border border-dashed border-ds-primary-400 bg-ds-primary-100 p-4"
            @submit.prevent="onSubmit"
        >
            <div class="grid grid-cols-[auto,auto,auto,auto] items-start gap-4">
                <DsCheckbox
                    v-model="selectedCheckboxes"
                    :label="label1"
                    name="example"
                    value="one"
                />
                <DsCheckbox
                    v-model="selectedCheckboxes"
                    :label="label2"
                    name="example"
                    value="two"
                />
                <DsCheckbox
                    v-model="selectedCheckboxes"
                    :label="label3"
                    name="example"
                    value="three"
                />
                <DsCheckbox
                    v-model="selectedCheckboxes"
                    :label="label4"
                    name="example"
                    value="four"
                />
            </div>
            <button class="mt-4 rounded-sm bg-ds-gray-900 px-4 py-2 text-white">Submit</button>
        </form>

        <div>
            Selected value: <strong>{{ selectedCheckboxes.join() }}</strong>
        </div>
        <div>
            Submitted value: <strong>{{ submittedVal }}</strong>
        </div>

        <div class="mt-8 rounded-md border border-dashed border-ds-primary-400 bg-ds-primary-100 p-4">
            <h3 class="mb-4 text-lg font-medium">Disabled Checkboxes</h3>
            <div class="grid grid-cols-[auto,auto,auto,auto] items-start gap-4">
                <DsCheckbox
                    v-model="selectedDisabledCheckboxes"
                    :label="label5"
                    name="disabled-example-five"
                    value="five"
                />
                <DsCheckbox
                    v-model="selectedDisabledCheckboxes"
                    disabled
                    :label="label6"
                    name="disabled-example-six"
                    value="six"
                />
                <DsCheckbox
                    v-model="selectedDisabledCheckboxes"
                    disabled
                    :label="label7"
                    name="disabled-example-seven"
                    value="seven"
                />
                <DsCheckbox
                    v-model="selectedDisabledCheckboxes"
                    :label="label8"
                    name="disabled-example-eight"
                    value="eight"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsCheckbox from '@ds/form/input/DsCheckbox.vue';
import { computed, ref } from 'vue';

const selectedCheckboxes = ref(['three']);
const submittedVal = ref();
const showLabels = ref(true);

const selectedDisabledCheckboxes = ref(['seven']);

const label1 = computed(() => (showLabels.value ? 'One' : ''));
const label2 = computed(() => (showLabels.value ? 'Two' : ''));
const label3 = computed(() => (showLabels.value ? 'Three' : ''));
const label4 = computed(() =>
    showLabels.value
        ? 'Fourem ipsum dolor sit, amet consectetur adipisicing elit. Expedita illum incidunt minima velit doloremque reprehenderit repudiandae ipsum possimus provident error quod repellat eligendi, mollitia molestiae, laudantium necessitatibus quos totam aspernatur. Iste laborum modi accusantium quo nesciunt perferendis fugit? Non, magni!'
        : '',
);
const label5 = computed(() => (showLabels.value ? 'Five' : ''));
const label6 = computed(() => (showLabels.value ? 'Six' : ''));
const label7 = computed(() => (showLabels.value ? 'Seven' : ''));
const label8 = computed(() =>
    showLabels.value
        ? 'Fourem ipsum dolor sit, amet consectetur adipisicing elit. Expedita illum incidunt minima velit doloremque reprehenderit repudiandae ipsum possimus provident error quod repellat eligendi, mollitia molestiae, laudantium necessitatibus quos totam aspernatur. Iste laborum modi accusantium quo nesciunt perferendis fugit? Non, magni!'
        : '',
);

const onSubmit = (evt: Event) => {
    const formData = new FormData(evt.target as HTMLFormElement);
    submittedVal.value = formData.getAll('example').join();
};
</script>
